import React from 'react';

import { useIntl } from 'react-intl';

export const BillingSameAsDeliveryLabel = () => {
  const { formatMessage } = useIntl();

  return <span>{formatMessage({ id: 'billingAddressIsSameAsDeliveryAddress' })}</span>;
};

export const SaveCardForFutureLabel = () => {
  const { formatMessage } = useIntl();

  return <span>{formatMessage({ id: 'saveCardDisclaimer' })}</span>;
};
